import { FeatureFlag } from '../FeatureFlag';

export const systemMessage = new FeatureFlag({
    key: 'system-message',
    createdOn: '2024-09-09',
    defaultValue: '',
});
